import { TENANT_PUBLIC_INFO } from "@/configs/publicTenantConfig";

const HOST_TENANT_REGEX = /^(dev-)?plus-([a-z]{2})\.(.+)$/i;

function ensureMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

function ensureManagedLink(selector, attrs) {
  let link = document.head.querySelector(selector);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("data-seo-managed", "true");
    document.head.appendChild(link);
  }

  Object.entries(attrs).forEach(([key, value]) => {
    link.setAttribute(key, value);
  });
}

function getHostSegments(hostname = window.location.hostname) {
  const match = hostname.match(HOST_TENANT_REGEX);
  if (!match) {
    return null;
  }

  return {
    devPrefix: match[1] || "",
    tenant: match[2].toUpperCase(),
    baseDomain: match[3],
  };
}

export function getCurrentTenantFromHostname(hostname = window.location.hostname) {
  return getHostSegments(hostname)?.tenant || null;
}

export function buildTenantUrl(tenantCode, path = "/", hostname = window.location.hostname) {
  const host = getHostSegments(hostname);
  if (!host || !tenantCode) {
    return `${window.location.origin}${path}`;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const targetHost = `${host.devPrefix}plus-${tenantCode.toLowerCase()}.${host.baseDomain}`;
  return `${window.location.protocol}//${targetHost}${normalizedPath}`;
}

function buildDefaultPlatformUrl(path = "/", hostname = window.location.hostname) {
  const host = getHostSegments(hostname);
  if (!host) {
    return `${window.location.origin}${path}`;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const defaultHost = `${host.devPrefix}plus.${host.baseDomain}`;
  return `${window.location.protocol}//${defaultHost}${normalizedPath}`;
}

export function applyPublicSeoTags() {
  const tenant = getCurrentTenantFromHostname();
  const tenantInfo = TENANT_PUBLIC_INFO[tenant];

  if (!tenant || !tenantInfo) {
    return;
  }

  const canonicalPath = `${window.location.pathname}${window.location.search}`;
  const title = `Bridgestone Plus ${tenantInfo.name} (${tenantInfo.code})`;
  const description = `Official Bridgestone Plus platform for ${tenantInfo.name} (${tenantInfo.code}).`;

  document.title = title;
  ensureMeta("description", description);

  ensureManagedLink('link[rel="canonical"][data-seo-managed="true"]', {
    rel: "canonical",
    href: buildTenantUrl(tenant, canonicalPath),
  });

  const oldAlternateLinks = document.head.querySelectorAll(
    'link[rel="alternate"][data-seo-managed="true"]'
  );
  oldAlternateLinks.forEach((link) => link.remove());

  Object.values(TENANT_PUBLIC_INFO).forEach((item) => {
    const hreflang = item.hreflang || item.locale;
    const selector = `link[rel="alternate"][hreflang="${hreflang}"][data-seo-managed="true"]`;
    ensureManagedLink(selector, {
      rel: "alternate",
      hreflang,
      href: buildTenantUrl(item.code, window.location.pathname),
    });
  });

  ensureManagedLink('link[rel="alternate"][hreflang="x-default"][data-seo-managed="true"]', {
    rel: "alternate",
    hreflang: "x-default",
    href: buildDefaultPlatformUrl(window.location.pathname),
  });
}

